<div class="header-bar">
  <h1>Home</h1>
</div>
<div class="content-container">
  <div class="card card-w-title">
    <div class="ui-g">
      <div class="ui-g-12">
        <h2 class="sub-header-bar">Job Volumes</h2>

        <div class="ui-g ui-g-12">
          <div class="ui-lg-3 ui-g-4 ui-sm-12">
            <div class="job-volumes param-1">
              <div class="ui-g-2 text-center"><i class="vme-material-icons">&#xe913;</i></div>

              <div class="ui-g-7">
                <a (click)="goToExistingJobs($event, supplierInboxType_Live)">Live Jobs</a>
              </div>
              <div class="ui-g-3 param-value">{{ data.liveJobs }}</div>
            </div>
          </div>
          <div class="ui-lg-3 ui-g-4 ui-sm-12" style="padding-bottom: 1em">
            <div class="job-volumes param-2">
              <div class="ui-g-2 text-center">
                <i class="vme-material-icons" style="font-size: 12px; margin-top: 10px">&#xe907;</i>
              </div>

              <div class="ui-g-7">
                <a (click)="goToInbox($event, supplierInboxType_InboxDirect)">Direct To You</a>
              </div>
              <div class="ui-g-3 param-value">{{ data.directToYou }}</div>
            </div>
          </div>
          <div class="ui-lg-3 ui-g-4 ui-sm-12">
            <div class="job-volumes param-3">
              <div class="ui-g-2 text-center"><i class="fa fa-eye fa-12x"></i></div>

              <div class="ui-g-7">
                <a (click)="goToInbox($event, supplierInboxType_InboxBidWatch)">Watched</a>
              </div>
              <div class="ui-g-3 param-value">{{ data.bidAndWatched }}</div>
            </div>
          </div>
          <div class="ui-lg-3 ui-g-4 ui-sm-12">
            <div class="job-volumes param-4">
              <div class="ui-g-2 text-center" style="padding-top: 1em">
                <i class="vme-material-icons">&#xe81f;</i>
              </div>

              <div class="ui-g-7">
                <a (click)="goToInbox($event, supplierInboxType_InboxMatched)">Matched</a>
              </div>
              <div class="ui-g-3 param-value">{{ data.matched }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="ui-g-12">
        <app-weekly-calendar></app-weekly-calendar>
      </div>

      <div class="ui-g-6 ui-sm-12">
        <h2 class="sub-header-bar">Live Driver Map</h2>

        <div style="height: 100%">
          <map-control
            [tasks]="taskList"
            [readOnly]="true"
            (selectedTaskChange)="taskClick($event)"
            [customStyle]="{ height: 'calc(100% - (33px))' }"
          ></map-control>
        </div>
      </div>

      <div class="ui-g-6 ui-sm-12">
        <div class="ui-g-12" *ngIf="false">
          <h2 class="sub-header-bar">Driver Status</h2>
          <div class="ui-g">
            <div class="ui-g-4">
              <div class="driver-status">
                <div class="ui-g-8">Start Movement</div>
                <div class="ui-g-4 param-value">{{ data.startMovement }}</div>
              </div>
            </div>
            <div class="ui-g-4">
              <div class="driver-status">
                <div class="ui-g-8">End Movement</div>
                <div class="ui-g-4 param-value">{{ data.endMovement }}</div>
              </div>
            </div>
            <div class="ui-g-4">
              <div class="driver-status">
                <div class="ui-g-8">Complete Job</div>
                <div class="ui-g-4 param-value">{{ data.completeJob }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="mb-3">
          <h2 class="sub-header-bar">Jobs By Day</h2>

          <p-chart type="bar" [data]="jobsByDay" [options]="jobsByDayOptions"></p-chart>
        </div>

        <div class="mb-3">
          <h2 class="sub-header-bar">Jobs Starting By Hour Band</h2>

          <p-chart type="bar" [data]="jobsByHour" [options]="jobsByHourOptions"></p-chart>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog
  [(visible)]="showUpdateAvaialbilityDialog"
  [responsive]="true"
  [modal]="true"
  [closeOnEscape]="false"
  (onHide)="(!showUpdateAvaialbilityDialog)"
  header="Information Required!"
  [closable]="true"
>
  <div class="ui-grid ui-grid-responsive ui-fluid">
    <div class="grid">
      <div class="col-4 sm:col-3 md:col-2">
        <i class="pi pi-calendar" style="font-size: 6em"></i>
      </div>
      <div class="col-8 sm:col-9 md:col-10">
        <div class="mt-4">
          Our records show that your availability information is not up to date.<br />
          Your availability will now default to Unset rather than Available. <br />
          As such it’s really important that you please tell us when you are available or
          unavailable to work by toggling the calendar.<br />
          This will mean you can receive text alerts on suitable jobs for you, and help us to direct
          the right jobs to you.
        </div>
      </div>
    </div>
  </div>
  <p-footer class="text-center mt-2">
    <button
      type="button"
      pButton
      label="My Schedule"
      (click)="goToMySchedule()"
      class="ui-button green-btn"
    ></button>
  </p-footer>
</p-dialog>
